<template>
  <pro-provider :i18n="t" :content-width="contentWidth">
    <a-layout class="ant-pro-basicLayout">
      <template v-if="isMobile">
        <a-drawer
          :bodyStyle="{ padding: 0, height: '100%' }"
          placement="left"
          :width="sideWidth"
          :closable="false"
          :visible="!collapsed"
          @update:visible="updateCollapsed"
        >
          <sider-menu
            style="height: 100%"
            :theme="theme"
            :layout="layout"
            :fixed="fixedSidebar"
            :menus="menus"
            :sider-width="sideWidth"
            :split-menus="false"
            :collapsed-button="false"
            :collapsed="false"
            v-model:open-keys="openKeys"
            v-model:selected-keys="selectedKeys"
          />
        </a-drawer>
      </template>
      <sider-menu
        v-else-if="!hasTopMenu"
        :theme="theme"
        :layout="layout"
        :fixed="fixedSidebar"
        :menus="menus"
        :sider-width="sideWidth"
        :split-menus="splitMenus"
        :collapsed-button="!splitMenus"
        v-model:collapsed="collapsed"
        v-model:open-keys="openKeys"
        v-model:selected-keys="selectedKeys"
      />
      <a-layout>
        <header-view2
          :theme="theme"
          :layout="layout"
          :menus="menus"
          :sider-width="sideWidth"
          :has-sider-menu="hasSideMenu"
          :fixed-header="fixedHeader"
          :split-menus="splitMenus"
          v-model:collapsed="collapsed"
          v-model:open-keys="openKeys"
          v-model:selected-keys="selectedKeys"
        >
          <div>
            <a-input-group compact>
              <div v-if="currentUser?.role_flag_list?.length > 0">
                <a-select style="width: 85px; margin-top: 8px" v-model:value="select_jump">
                  <a-select-option
                    v-for="option in select_option_list"
                    :key="option.value"
                    :value="option.value"
                  >
                    {{ option.label }}
                  </a-select-option>
                </a-select>
                <a-input-search
                  placeholder="顾客名字/备注/电话/会员ID"
                  style="width: 260px; margin-top: 8px"
                  enter-button
                  @search="openSearch"
                />
              </div>
              <a-button
                v-if="select_button_dict.newcomer.is_show"
                style="margin-left: 3px; margin-right: 3px; margin-top: 8px"
                type="primary"
                @click="btn_obj.cb"
                ghost
              >
                <plus-outlined />
                新客
              </a-button>
              <!--              <a-button-->
              <!--                v-if="select_button_dict.reservation.is_show"-->
              <!--                type="primary"-->
              <!--                shape="round"-->
              <!--                style="margin-top: 8px"-->
              <!--                @click="goAppointment"-->
              <!--              >-->
              <!--                预约-->
              <!--              </a-button>-->
              <a-tooltip>
                <template #title>
                  <span>通知</span>
                </template>
                <a-badge :dot="unread_count > 0" :offset="[-13, 13]">
                  <bell-outlined
                    style="margin-top: 12px; font-size: 22px; margin-right: 10px; margin-left: 10px"
                    @click="to_tips"
                  />
                </a-badge>
              </a-tooltip>
              <shop-name-now :shop_list="shop_list" :current_shop="current_shop" />
              <avatar-dropdown :current-user="currentUser" />
              <org-name-now :org_list="org_list" :current_org="current_org" />
            </a-input-group>
          </div>
        </header-view2>
        <multi-tab v-if="multiTab" :fixed="multiTabFixed" :sider-width="sideWidth" />
        <router-view v-slot="{ Component }">
          <wrap-content>
            <component :is="Component"></component>
          </wrap-content>
        </router-view>
      </a-layout>
    </a-layout>
    <!--    <setting-drawer />-->
  </pro-provider>
  <component
    :is="modal.component ? modal.component : 'form-modal'"
    v-for="modal in modal_list"
    :key="modal.id"
    v-bind="modal"
    @ok="
      data => {
        modal_ok(data, modal);
      }
    "
    @cancel="
      data => {
        modal_cancel(data, modal);
      }
    "
  ></component>
</template>

<script lang="ts">
import { defineComponent, computed, inject, ref, reactive, getCurrentInstance } from 'vue';
import { useI18n } from 'vue-i18n';
import { genMenuInfo } from '@/utils/menu-util';
import { default as WrapContent } from '@/components/base-layouts/wrap-content/index.vue';
import { default as GlobalFooter } from '@/components/base-layouts/global-footer/index.vue';
import { default as SiderMenu } from '@/components/base-layouts/sider-menu/index.vue';
import { default as HeaderView2 } from '@/components/base-layouts/header/index2.vue';
import { default as SelectLang } from '@/components/select-lang/index.vue';
import { default as SettingDrawer } from '@/components/setting-drawer/index.vue';
import { MultiTab } from '@/components/multi-tab';
import { useStore } from 'vuex';
import { injectMenuState } from './use-menu-state';
import isGotoOldRouter from '@/router/return-old-router';
import { default as mqttState } from '@/components/mqtt-state.vue';
import FormModal from '@/components/form-modal/form-modal.vue';
import { PlusOutlined, BellOutlined } from '@ant-design/icons-vue';
import { btn_obj } from '@/layouts/create-customer.ts';
import TableModal from '@/components/TableModel/TableModal.vue';
import { useRouter } from 'vue-router';
import { default as AvatarDropdown } from '@/components/avatar-dropdown.vue';
import { default as ShopNameNow } from '@/components/shop-name-now.vue';
import { default as OrgNameNow } from '@/components/org-name-now.vue';
import { query_card_record_time_alert_list } from '@/api/mjstore-model';
import modalBox from '@/components/form-modal/modal-tools';

export default defineComponent({
  name: 'BasicLayout',
  setup() {
    const store = useStore();
    const router = useRouter();
    const { t } = useI18n();
    const menuState = injectMenuState();
    const select_jump: any = ref('1');
    const isMobile = inject('isMobile', ref(false));
    const currentUser = computed(() => store.getters['user/currentUser']);
    const current_org = computed(() => store.getters['user/current_org']);
    const org_list = computed(() => store.getters['user/org_list']);
    const shop_list = computed(() => store.getters['user/shop_list']);
    const current_shop = computed(() => store.getters['user/current_shop']);
    const hasSideMenu = computed(
      () => menuState.layout.value === 'side' || menuState.layout.value === 'left',
    );
    const hasTopMenu = computed(() => menuState.layout.value === 'top');

    const modal_list: any = reactive([]);
    let $bus: {
      emit: (arg0: string, arg1: any) => void;
      off: (arg0: string) => void;
      on: (arg0: string, arg1: any) => void;
    } | null = null;
    $bus = getCurrentInstance()?.appContext.config.globalProperties.$bus;

    $bus?.on('modal.add', (modal: any) => {
      if (!modal.id) {
        modal.id = Date.now();
      }
      modal_list.push(modal);
    });
    const select_button_dict: any = ref({
      newcomer: { name: '新客', show_role_flag: ['shop_manager', 'admin'], is_show: false },
      reservation: { name: '预约', show_role_flag: ['shop_manager', 'admin'], is_show: false },
    });
    const source_select_option_list = [
      {
        value: '1',
        label: '顾客',
        show_role_flag: ['admin', 'shop_manager', 'chairman', 'senior_manager',
          'information_dept',
          'outsiders',
          'primary_adviser',
          'intermediate_adviser',
          'senior_adviser',
          'marketing_acting_manager',
          'marketing_manager',
          'marketing_chief',
          'primary_doctor',
          'intermediate_doctor',
          'senior_doctor',
          'tech_acting_manager',
          'tech_acting_manager',
          'tech_chief',
        ],
      },
      { value: '2', label: '加盟商', show_role_flag: ['admin', 'supply_keeper', 'supply_manager'] },
      {
        value: '3',
        label: '库存',
        show_role_flag: ['admin', 'supply_keeper', 'supply_manager', 'shop_manager'],
      },
    ];
    const select_option_list = ref(new Array<any>());
    select_option_list.value = source_select_option_list.filter((item: any) => {
      return item.show_role_flag.some((obj: any) => {
        return currentUser.value.role_flag_list.indexOf(obj) > -1;
      });
    });
    for (let key in select_button_dict.value) {
      const some = select_button_dict.value[key as string].show_role_flag.some((obj: any) => {
        return currentUser.value.role_flag_list.indexOf(obj) > -1;
      });
      if (some) {
        select_button_dict.value[key as string].is_show = true;
      } else {
        select_button_dict.value[key as string].is_show = false;
      }
    }
    if (select_option_list.value && select_option_list.value.length > 0) {
      select_jump.value = select_option_list.value[0].value;
    }
    const modal_ok = (data: any, modal: any) => {
      if (modal.ok) {
        const result = modal.ok(data, modal);
        if (result instanceof Promise) {
          result.then(function () {
            modal_list.splice(modal_list.indexOf(modal, 0), 1);
          });
        } else if (result === true || result === null || result === undefined) {
          modal_list.splice(modal_list.indexOf(modal, 0), 1);
        }
      } else {
        modal_list.splice(modal_list.indexOf(modal, 0), 1);
      }
    };

    const modal_cancel = (data: any, modal: any) => {
      if (modal.cancel) {
        modal.cancel(data, modal);
      }
      modal_list.splice(modal_list.indexOf(modal, 0), 1);
    };

    // gen menus
    const allowRouters = computed(() => store.getters[`user/allowRouters`]); // genMenuInfo(filterMenu(routes)).menus;
    const menus = computed(() => genMenuInfo(allowRouters.value).menus);
    // 返回旧版本
    const returnOldRouter = (selectedKeys: any) => {
      isGotoOldRouter(selectedKeys[selectedKeys.length - 1]);
    };

    const field = reactive({
      visible: false,
      title: '搜索用户',
      mode: 'default',
      search_text: '',
    });
    const openSearch = (searchValue: string) => {
      if (searchValue && select_jump.value == '1') {
        router.push({
          path: '/business_manage/mjstore-customer',
          query: { q: searchValue, t: new Date().getTime() },
        });
      } else if (searchValue && select_jump.value == '2') {
        router.push({
          path: '/mjstore_company/jms-franchisee',
          query: { q: searchValue, t: new Date().getTime() },
        });
      } else if (searchValue && select_jump.value == '3') {
        router.push({
          path: '/mjstock/caigou/mjstock-productinrecord1',
          query: { q: searchValue, t: new Date().getTime() },
        });
      }
    };
    // const goBasic = (data: any) => {
    //   if (data) {
    //     router.push({ path: '/business_manage/profile/basic/' + data });
    //   }
    //   field.visible = false;
    // };
    const list: any = [];
    const unread_count: any = ref(0);
    query_card_record_time_alert_list({
      org_id: current_org.value.id,
      shop_id: current_shop.value?.id,
    }).then((res: any) => {
      unread_count.value = res.unread_count;
      res.data.map((item: any) => {
        list.push(item);
      });
    });
    const to_tips = () => {
      const editModal = reactive({
        visible: true,
        title: '通知',
        component: 'TipsModal',
        list: list,
      });
      modalBox(editModal);
    };
    const goAppointment = () => {
      router.push({ path: '/workplace/meili-0' });
    };

    return {
      t,
      current_shop,
      shop_list,
      field,
      select_jump,
      current_org,
      menus,
      ...menuState,
      hasSideMenu,
      hasTopMenu,
      isMobile,
      // goBasic,
      goAppointment,
      to_tips,
      btn_obj,
      currentUser,
      org_list,
      returnOldRouter,
      isGotoOldRouter,
      modal_list,
      modal_ok,
      modal_cancel,
      openSearch,
      select_option_list,
      unread_count,
      select_button_dict,
    };
  },
  components: {
    FormModal,
    MultiTab,
    WrapContent,
    SiderMenu,
    GlobalFooter,
    HeaderView2,
    SelectLang,
    SettingDrawer,
    mqttState,
    TableModal,
    PlusOutlined,
    BellOutlined,

    AvatarDropdown,
    ShopNameNow,
    OrgNameNow,
  },
});
</script>

<style lang="less">
@import '../components/base-layouts/basic-layout.less';
</style>
